import { GetterTree } from 'vuex';
import { format } from 'date-fns';
import { JobInput, JobState } from './state';

export const getters: GetterTree<JobState, any> = {
  formattedStartDate(state): string {
    if (!state.startDate) return '';
    return format(new Date(state.startDate), 'eeee, MMMM d, yyyy');
  },
  reservationFromQueryParam(state): string | null {
    return state.reservationId;
  },
  jobInput(state: JobState): JobInput {
    return state.jobInput;
  },
};

export default getters;
